(function() {
    'use strict';

    angular
        .module('receiptApp')
        .controller('AuditConfirmController',AuditConfirmController);

    AuditConfirmController.$inject = ['$uibModalInstance','detailMessage', 'fileUpload1', 'fileUpload2', 'receipt'];

    function AuditConfirmController($uibModalInstance, detailMessage, fileUpload1, fileUpload2, receipt) {
        var vm = this;
        vm.confirm = confirm;
        vm.detailMessage = detailMessage;
        vm.fileUpload1 = fileUpload1;
        vm.fileUpload2 = fileUpload2;
        vm.receipt = receipt;
        
        function confirm(numChoose) {
        	$uibModalInstance.close(numChoose);
        }
    }
})();
